<div class="{{layoutName}}-page" [class.contact-form-open]="isContactFormOpened$ | async">
  <router-outlet></router-outlet>
</div>

<div class="page-loader" [class.is-loading]="pageLoader.isLoading$ | async">
  <loader-spinner [model]="pageLoader"/>
</div>

<div class="page-notifications">
  @for (notification of notifications(); track notification; let index = $index) {
    <notification-message [notification]="notification"
      (dismissEvent)="removeNotification(index)"/>
  }
</div>
